import {
  Button,
  Card,
  Divider,
  Grid,
  Snackbar,
  Table,
  TableBody,
  TableHead,
  Typography,
  Alert as MuiAlert,
  CardContent,
  TableContainer,
} from '@mui/material'
import { Add as AddIcon } from '@mui/icons-material'
import { useEffect, useState, forwardRef } from 'react'
import { Helmet } from 'react-helmet-async'
import { useNavigate } from 'react-router-dom'
import { businessCheck } from '../../utils/utils'
import PayPerUserPurchaseOrderTypeDialog from './host/purchaseOrderTypeDialog'
import { SnackBarHideDuration, SnackBarTransition, StyledTableCell, StyledTableRow } from '../../utils/ui_utils'
import { useSubscriptionOrderTypeCreate, useSubscriptionOrderTypeFetch } from '../../modules/subscriptionPurchaseOrderType/subsOrderTypeHooks'



function PayPerUserPurchaseOrderType() {
  const [orderTypeData, setOrderTypeData] = useState(null)

  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const [orderTypeDialogMode, setOrderTypeDialogMode] = useState('edit')
  const [orderTypeDialogVisibility, setOrderTypeDialogVisibility] = useState(false)
  const { subsOrderTypeCreateData, subsOrderTypeCreateError, subsOrderTypeCreateLoading, createSubscriptionOrderType } = useSubscriptionOrderTypeCreate();
  const { subsOrderTypeData, subsOrderTypeError, subsOrderTypeLoading, fetchSubscriptionOrderType } = useSubscriptionOrderTypeFetch();
  const handleSnackbarClose = () => {
    setSnackBar(false)
  }
  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  const history = useNavigate()

  useEffect(() => {
    businessCheck(history);
    fetchSubscriptionOrderType();
  }, [])

  if (subsOrderTypeError) return <p>Error!</p>
  if (subsOrderTypeLoading) return <p>Loading...</p>

  return (
    <>
      <Helmet title="Subscription Purchase Order Types" />
      <Grid container sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

        <Grid item xs={9} md={6}>

          <Typography variant="h4" gutterBottom display="inline">
            Subscription Purchase Order Types
          </Typography>
        </Grid>
        <Grid item>
          <Button startIcon={<AddIcon />}
            variant="contained"
            size="small"
            color="primary" onClick={() => {
              setOrderTypeDialogMode("new")
              setOrderTypeData({
                short_name: '',
              })
              setOrderTypeDialogVisibility(true)
            }}>
            Create Purchase Order Type
          </Button>
          <PayPerUserPurchaseOrderTypeDialog
            initialValues={orderTypeData}
            visible={orderTypeDialogVisibility}
            title={orderTypeDialogMode == 'new' ? "Create Order Type" : "Edit Type"}
            onSubmit={async (value) => {
              if (orderTypeDialogMode == 'new') {
                await createSubscriptionOrderType(value);
                if (subsOrderTypeCreateError) {
                  toastMessage("Purchase Order Type creation failed", "error")
                } else if (subsOrderTypeCreateData) {
                  toastMessage("Purchase Order Type created", "success")
                  fetchSubscriptionOrderType();
                  setOrderTypeDialogVisibility(false)
                }
              }
            }}
            onClose={() => setOrderTypeDialogVisibility(false)}
            okText={orderTypeDialogMode == 'new' ? "Create" : "Update"}
          />
        </Grid>
      </Grid>
      <Divider sx={{ marginTop: 5 }} />
      <Grid container spacing={10} sx={{ paddingTop: 5 }}>
        <Grid item xs={3} lg={3}>
          <Card raised sx={{ borderRadius: 3 }}>
            <CardContent sx={{ flexGrow: 1 }}>
              <TableContainer component={Card}>
                <Table size="small">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>Name</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {subsOrderTypeData.map((row) => (
                      <StyledTableRow key={row._id} hover >
                        <StyledTableCell >
                          {row.short_name}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </>
  )
}
export default PayPerUserPurchaseOrderType
